import { useItem } from "../../../fetch/fetch.item.ts";
import ErrMessage from "../../core/ErrMessage.tsx";
import { EMPTY_ITEM } from "../../../const/typeDefault/Item.ts";
import { ItemType } from "../../../types/Item.ts";
import { ReactNode } from "react";

const ItemFetch = ({
  id,
  children,
  fallback,
}: {
  id: string;
  children: (item: ItemType) => ReactNode;
  fallback: ReactNode;
}) => {
  const { item, isLoading, isError } = useItem(id, EMPTY_ITEM);
  if (isLoading) return fallback;
  if (isError) return <ErrMessage message={isError} />;
  return children(item);
};
export default ItemFetch;
